(function ( $ ) {
    $.fn.evaluationQuestionOptionGroupSelector = function(val, params) {
        $(this).each(function() {
            const elm = $(this);

            elm.attr('data-search-type', 'evaluation-question-option-group');


            const onChange = function(obj) {
                try {
                    if(typeof obj === 'string') {
                        obj = JSON.parse(obj);
                    }
                    console.log({obj});
                    elm.removeClass('has-special-selector').evaluationQuestionOptionGroupSelector(obj.id, params);
                } catch(e) {

                }
            };

            elm.specialSelector({
                val: val,
                option: function(row) {
                    return '<option value="'+row.id+'">' + row.name + '</option>';
                },
                addNew: () => {
                    add_evaluation_question_option_group({
                        callback: onChange
                    });
                },
                onOpen: function(id) {
                    view_evaluation_question_option_group(id);
                }
            });
        });
        return this;
    };

}( jQuery ));